import _ = require('underscore');
import { ISelectFilterDefinitionOption } from '~src/content/services/FilterPanelService';
import { AuthenticationProviderType } from '~src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';

export module AuthenticationFilterHelper {
  export const AnyAuthType = 'Any';

  const allOptions = [
    AuthenticationProviderType.default,
    AuthenticationProviderType.oidc,
    AuthenticationProviderType.saml,
    AuthenticationProviderType.tabidmfa
  ];

  export function getAllOptions(): string[] {
    return allOptions;
  }

  export function getOptionsForSite(authTypeForSite: string[]): ISelectFilterDefinitionOption<string>[] {

    return authenticationOptions(_.intersection(allOptions, authTypeForSite));
  }

  export function getMessageForAuthType(authType: string): string {
    let translateKey;
    switch(authType) {
      case  'DEFAULT':
        translateKey = 'ssoAuthTypeDefault_name_tableauid';
        break;
      case 'TABID_WITH_MFA':
        translateKey = 'ssoAuthTypeDefault_name_tableauid_mfa';
        break;
      case 'OIDC':
        translateKey = 'ssoAuthTypeOIDC_name_undefined';
        break;
      case 'SAML':
        translateKey = 'ssoAuthTypeSAML_name_undefined';
        break;
      default:
        throw new Error(`Unsupported provider type`);
    }

    return translateKey;
  }

  export function authenticationOptions(authTypes: string[]) {
    const options: ISelectFilterDefinitionOption<string>[] = [
      {
        value: AnyAuthType,
        translate: 'ssoAuthenticationAny'
      }
    ];

    _.each(authTypes, (authType: string) => {
      options.push({
        value: authType,
        translate: getMessageForAuthType(authType),
      });

    });
    return options;
  }
}
